import { render, staticRenderFns } from "./RegistrationSymbol.vue?vue&type=template&id=4585de82&"
import script from "./RegistrationSymbol.vue?vue&type=script&lang=js&"
export * from "./RegistrationSymbol.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationSymbol.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\JIT002729\\solas\\fc\\JIT\\frontDev_2\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4585de82')) {
      api.createRecord('4585de82', component.options)
    } else {
      api.reload('4585de82', component.options)
    }
    module.hot.accept("./RegistrationSymbol.vue?vue&type=template&id=4585de82&", function () {
      api.rerender('4585de82', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/molecules/form/autocomplete/RegistrationSymbol.vue"
export default component.exports